import { render, staticRenderFns } from "./Youcontrol.vue?vue&type=template&id=35da79c5&scoped=true"
import script from "./Youcontrol.vue?vue&type=script&lang=js"
export * from "./Youcontrol.vue?vue&type=script&lang=js"
import style0 from "./Youcontrol.vue?vue&type=style&index=0&id=35da79c5&prod&lang=css"
import style1 from "./Youcontrol.vue?vue&type=style&index=1&id=35da79c5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35da79c5",
  null
  
)

export default component.exports